/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-layout custom-class="custom-class" :useDefaultNavbar="(false)" :layout="(['header'])" navbarStyle="" blankPageType="blank-page" @blank-retry="init" :esMainStyle="({background:'transparent'})"><div slot="header"><es-navbar :left-arrow="(true)"><change-navbar :process="(0)"/></es-navbar></div><div class="refund-main"><select-station @handleClick="handleClick" :toStation="(toStation)" :startTime="(selectDateValue)" :limit="(limitDate.limitForChange)" :isCross="(isCross)"/><tips-card title="改签预定须知" sideTitle="查看详情" :sideIcon="(true)" :texts="(tips)" @sideClick="toPurchaseNotice"/></div></es-layout><es-popup :value="travelCalendarVisible" mpxModelEvent="input" @mpxModel='__model("travelCalendarVisible", $event, ["value"], undefined)' position="bottom" :closeable="(true)"><es-calendar ref="calendar" type="single" title="选择前往日期" :showConfirm="(false)" :value="selectDateValue" mpxModelEvent="input" @mpxModel='__model("selectDateValue", $event, ["value"], undefined)' :maxDate="(limitDate.maxDate)" :minDate="(limitDate.minDate)" @confirm="onConfirm"></es-calendar></es-popup></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mb04e0524"}'>
  @import '~@/mixins/stylus/color.styl'

  $current-main-color = #FF7C46
  .custom-class
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/9LEPzaGxxj1663308781690.png')
    background-repeat no-repeat
    background-position center center
    background-size cover
  .refund-main
    height 100%
    padding-left 12px
    padding-right 12px
    padding-bottom 134px
    overflow auto
    box-sizing border-box
  // .calendar-tip
  //   margin 4px 16px
  //   border-radius 8px
  //   background rgba(255, 244, 238, 0.5)
  //   box-sizing border-box
  //   padding 7px 12px
  //   font-family PingFangSC-Regular
  //   font-size 12px
  //   font-weight normal
  //   line-height 16px
  //   letter-spacing 0px
  //   color #FF6F2A
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mb04e0524"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-ticket-page.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-ticket-page.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mb04e0524"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'select-station':getComponent(require("./components/select-station.mpx?isComponent&outputPath=components%2Fselect-stationfebbfea2%2Findex")),'change-navbar':getComponent(require("../../components/change-navbar/index.mpx?isComponent&outputPath=components%2Findex262f9081%2Findex")),'tips-card':getComponent(require("../../components/tips-card/index.mpx?isComponent&outputPath=components%2Findex7169e18e%2Findex")),'es-calendar':getComponent(require("../../components/calendar/index.mpx?isComponent&outputPath=components%2Findex2f88bd1e%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
